import row from './row.vue'

row.install = function(Vue) {
  Vue.component(row.name, row)
}

export default row
